import React from 'react';
import { useHistory } from 'react-router-dom';
import useBooleanHandlers from '../../../../../../../../hooks/useBooleanHandlers';
import { useTrans } from '../../../../../../../../services/i18n';
import SimpleSearchField from '../../../../../../../../components/generics/SearchTopPanel/SearchField/SimpleSearchField';
import connect from '../../../../../connect';

const Search = ({ textSearch, onClearSearch, filters, changeFilters }) => {
  const { trans } = useTrans();
  const { location } = useHistory();
  const [focused, onFocus, onBlur] = useBooleanHandlers();

  const handleChange = React.useCallback(
    (value) => {
      onClearSearch(value || '');
      onBlur();
      const copyFilters = { ...filters };
      copyFilters.text = value;
      copyFilters.pagination = { ...filters.pagination, page: 1 };
      changeFilters(copyFilters);
    },
    [changeFilters, filters, location.pathname, onBlur, onClearSearch]
  );

  return (
    <SimpleSearchField
      value={textSearch}
      onValueChange={handleChange}
      name="ezSearch"
      size="medium"
      bgColor="default"
      placeholder={trans('search')}
      freeSolo
      onFocus={onFocus}
    />
  );
};

export default connect(Search);
